export default {
  'health': {
    'aggregateData': {
      'registeredUsers': 'Usuarios registrados',
      'activeUsers': 'Usuarios activos',
      'hoursOfActivity': 'Horas de actividad',
      'hoursOfSleep': 'Horas de sueño',
      'kgC02Saving': 'kg de ahorros C02',
      'steps': 'Pasos',
      'kmTravelled': 'km recorridos',
      'savedTrees': 'Árboles salvados',
      'smartphoneCharges': 'Cargas móbiles',
      'co2ToElectricEnergy': 'CO2 a energía eléctrica',
      'sleepTrend': 'Evolución del sueño',
      'activityTrend': 'Evolución de la actividad',
      'stepsTrend': 'Evolución de los pasos',
      'distanceTrend': 'Evolución de la distancia',
      'corporateDashboard': 'Dashboard corporativo'
    },
    'nightScout': 'Nightscout',
    'changePassphrase': {
      'title': 'Cambiar contraseña',
      'success': 'La contraseña se ha actualizado correctamente',
      'error': 'Ha ocurrido un error al cambiar la contraseña',
      'generate': 'Generar',
      'passphraseInUse': 'La contraseña ya está en uso'
    },
    'healthBoard': 'Glucoboard',
    'my-patients': {
      'title': 'Mis pacientes',
      'loading': 'Cargando pacientes...',
      'empty': 'No tienes pacientes asignados aún.',
      'retry': 'Reintentar',
      'error': 'Error al cargar los pacientes. Por favor, intenta de nuevo.',
      'table': {
        'id': 'ID',
        'username': 'Usuario',
        'name': 'Nombre',
        'surname': 'Apellido',
        'email': 'Email'
      }
    },
    'foodManager': {
      'title': 'Food Manager',
      'nameEsp': 'Nombre',
      'nameEng': 'Name (English)',
      'group': 'Grupo',
      'portion': 'Porción',
      'fat': 'Grasa(g)',
      'protein': 'Proteína(g)',
      'kcl': 'Kcals (kj)',
      'carbs': 'Carbs(g)',
      'fiber': 'Fibra(g)',
      'water': 'Agua(g)',
      'alcohol': 'Alcohol(g)',
      'successDelete': 'Alimento: {name} borrado',
      'errorDelete': 'Error borrando {name}'
    },
    'summary': {
      'meal': 'Tipo',
      'max': 'Estabilización nivel basal',
      'peak': 'Máximo Alcanzado',
      'diff': 'Diferencia Inicio/Fin',
      'title': 'Resumen',
      'glucoscore': 'Glucoscore',
      'button': 'Ver detalles macros',
      'caloriesUnit': 'Calorias (kcal)',
      'fatUnit': 'Grasas (g)',
      'proteinUnit': 'Proteinas (g)',
      'carbsUnit': 'Carbohidratos (g)',
      'calories': 'Calorias',
      'fat': 'Grasas',
      'protein': 'Proteinas',
      'carbs': 'Carbohidratos',
      'fibre': 'Fibra',
      'caloriesWeight': 'Calorias/kilo (kcal/kg)',
      'takeIntoAccount': 'Añadir al Resumen',
      'fatWeight': 'Grasas/kilo (g/kg)',
      'proteinWeight': 'Proteinas/kilo (g/kg)',
      'carbsWeight': 'Carbohidratos/kilo (g/kg)',
      'day': 'Día',
      'average': 'Promedio',
      'vibeBattery': 'VibeBattery',
      'weightTitle': '{value} kcals/kg',
      'kcalTitle': '{value} kcal',
      'grams': 'gramos',
      'kcals': 'kcals',
      'averageMacros': 'Promedio de Macronutrientes',
      'averageMacrosKilo': 'Promedio de Macronutrientes/kg',
      'greenScore': 'Bajo',
      'orangeScore': 'Moderado',
      'redScore': 'Alto',
      'impact': 'Impacto',
      'glucoscoreInfo': 'El Glucoscore valora el impacto que tiene una ingesta en tu curva glucémica. Esta métrica te ayuda a comprender cómo te afecta el conjunto de alimentos de tus ingestas.',
      'vibeBatteryInfo': 'Vibebattery es tu energía diaria. Es una relación matemática entre distintas variables, tanto objetivas como subjetivas, que representa el estado de tu organismo para soportar los distintos estímulos de la vida.',
      'isp': 'ISP (Índice de Saciedad Perdurable)',
      'macroDistribution': 'Distribución de Macronutrientes'
    },
    'gpxIngestFile': 'Fichero GPX',
    'integrate': 'integrate',
    'integration': {
      'success': '¡Integración completada con éxito!',
      'error': 'Ha ocurrido un error durante la integración.',
      'notEnoughScopes': 'Para completar la integración debes conceder todos los permisos solicitados',
      'noAccount': 'No hay una cuenta de Google Fit vinculada a tu cuenta de Google',
      'noRefreshToken': 'Ha ocurrido un error durante la integración. Por favor, retira el acceso desde la app de Google Fit e inténtalo de nuevo',
      'manageIntegration': 'Gestionar integración',
      'integrationModalText': '¿Qué te gustaría hacer con {platform}?',
      'reIntegrate': 'Volver a integrar',
      'removeIntegration': 'Eliminar integración',
      'integrationRemoved': 'La integración ha sido eliminada con éxito',
      'integrationRemovedError': 'Ha ocurrido un error al eliminar la integración'
    },
    'explorer': {
      'title': 'Glucoboard',
      'multipleBoard': {
        'title': 'Multipantalla',
        'selectUsers': 'Seleccionar usuarios'
      },
      'controls': 'Últimos 7 días desde',
      'controlsDay': 'Datos del día',
      'controls14': 'Últimos 14 días desde',
      'controls30': 'Últimos 30 días desde',
      'controls30Simple': 'Últimos 30 días',
      'userSelector': 'Mostrar datos del usuario',
      'groupSelector': 'Mostrar datos del grupo',
      'show': 'Mostrar',
      'heartRate': 'Pulso',
      'intensity': 'Intensidad',
      'sport': 'Deporte',
      'event': 'Evento',
      'foods': 'Alimentos',
      'amount': 'Cantidad',
      'carbohydrates': 'CH',
      'proteins': 'P',
      'fats': 'G',
      'questionnaire': {
        'notes': 'Notas',
        'fastingHunger': 'Hambre temprana',
        'glucoseBasal': 'Glucosa basal',
        'restingHr': 'Pulso en resposo',
        'hrVariability': 'HRV',
        'sickness': 'Enfermedad',
        'sleepQuality': 'Calidad de sueño',
        'sleepTime': 'Tiempo de sueño',
        'tiredness': 'Energía',
        'anxietyLevel': 'Nivel de ansiedad',
        'dayEvaluation': 'Valoración del día',
        'nutritionPlan': 'Nutrición excepcional',
        'outOfRoutine': 'Viaje o rutina especial',
        'trainingEffort': 'Esfuerzo en entrenamiento',
        'sleepTimeStart': 'Hora de acostarse',
        'sleepTimeEnd': 'Hora de levantarse',
        'yes': 'Si',
        'no': 'No'
      },
      'glucoscore': {
        'redScore': 'Impacto alto',
        'orangeScore': 'Impacto moderado',
        'greenScore': 'Impacto bajo',
        'auc': 'AUC',
        'peak': 'Pico',
        'stabilization': 'Estabilización',
        'amplitude': 'Amplitud',
        'couldNotCalculateYet': 'Se necesitan muestras de glucosa de las dos horas posteriores a la ingesta para que pueda ser evaluada.',
        'processing': 'Tu ingesta se está analizando, pronto podrás ver la valoración.',
        'notSamples': 'No se ha podido evaluar tu ingesta porque no muestras de glucosa.',
        'notEnoughSamples': 'No se ha podido evaluar tu ingesta porque no hay suficientes muestras de glucosa.',
        'duringSport': 'No se ha podido evaluar tu ingesta porque se ha realizado durante un periodo con actividad.',
        'beforeSport': 'No se ha podido evaluar tu ingesta porque se ha realizado poco antes de un periodo con actividad.',
        'tooCloseToMeal': 'No se ha podido evaluar tu ingesta porque se ha realizado en un periodo demasiado próximo a la anterior ingesta.',
        'notCalculated': 'No se ha podido calcular la evaluación de tu ingesta.'
      }
    },
    'settings': {
      'userSensorTime': 'Sensores Activos',
      'supervisors': 'Supervisores'
    },
    'supervisor': {
      'pending': 'Pendiente',
      'invite': 'Invitar',
      'usernameOrEmail': 'Nombre de usuario o email',
      'remove': '¿Estás seguro de que deseas retirarle los permisos?',
      'errorDelete': 'Ha ocurrido un error al retirar los permisos a {name}',
      'successDelete': '{name} ya no verá más tus datos',
      'successInvite': '{name} ha sido invitado a ver tus datos',
      'errorInvite': 'Ha ocurrido un error al invitar a {name}',
      'errorInviteNotFound': 'No se pudo encontrar a {name}',
      'errorConflictInvite': '{name} ya ha sido invitado para ver tus datos',
      'errorYourselfInvite': 'No puedes invitarte a ti mismo'
    },
    'manageAccess': {
      'title': 'Gestionar mi acceso',
      'removeAccessTitle': 'Eliminar acceso',
      'removeAccessMessage': '¿Estás seguro de que deseas eliminar el acceso?',
      'successAccessDelete': 'Se ha eliminado el acceso a {name}',
      'errorAccessDelete': 'Ha ocurrido un error al eliminar el acceso a {name}',
      'successAcceptInvitation': 'La invitación ha sido aceptada con éxito',
      'errorAcceptInvitation': 'Ha ocurrido un error al aceptar la invitación',
      'successDeclineInvitation': 'La invitación ha sido rechazada con éxito',
      'errorDeclineInvitation': 'Ha ocurrido un error al rechazar la invitación',
      'removePendingMessage': 'Rechazar invitación',
      'removePendingTitle': '¿Estás seguro de que deseas rechazar la invitación?',
      'invitations': 'Invitaciones'
    },
    'sensor': {
      'title': 'Sensores Activados',
      'time': 'Tiempo',
      'day': 'Día',
      'hour': 'Hora',
      'sensor': 'Sensor',
      'supervisor': 'Supervisor',
      'noSupervisor': 'No tiene supervisor'
    },
    'analytics': {
      'notFoundNames': {
        'menuTitle': 'Nombres erróneos',
        'title': 'Biomarcadores no encontrados',
        'columns': {
          'extractedName': 'Nombre extraído',
          'unit': 'Unidad',
          'value': 'Valor',
          'resolve': 'Resolver'
        },
        'selectPlaceholder': 'Selecciona biomarcador...',
        'recommended': 'Recomendadas',
        'otherBiomarkers': 'Resto de biomarcadores',
        'noUnit': 'Sin unidad',
        'accept': 'Aceptar',
        'reject': 'Rechazar',
        'alerts': {
          'selectFirst': 'Por favor, selecciona un biomarcador del desplegable primero.',
          'saveError': 'No se pudo guardar la resolución.',
          'rejectConfirm': '¿Estás seguro de que quieres rechazar \'{name}\'?',
          'rejectError': 'No se pudo rechazar el biomarcador.'
        }
      },
      'notFoundUnits': {
        'menuTitle': 'Unidades erróneas',
        'title': 'Revisión de Unidades de Biomarcadores',
        'originalUnit': 'Unidad extraída',
        'suggestedUnit': 'Unidad sugerida / Mapeo',
        'accept': 'Aceptar',
        'reject': 'Rechazar',
        'save': 'Guardar',
        'empty': 'No hay unidades pendientes de revisión.',
        'successAccept': 'Unidad mapeada y aceptada correctamente',
        'successReject': 'Unidad rechazada correctamente',
        'errorAction': 'Ha ocurrido un error al procesar la unidad'
      },
      'categories': {
        'menuTitle': 'Evaluar analíticas'
      },
      'history': {
        'menuTitle': 'Historial de analíticas'
      },
      'list': {
        'title': 'Historial de Analíticas',
        'date': 'Fecha',
        'notes': 'Notas / Detalles',
        'noNotes': 'Sin notas',
        'empty': 'No hay analíticas disponibles.'
      },
      'evaluation': {
        'title': 'Categorías de la Analítica',
        'categoryFallback': 'Categoría',
        'biomarkerFallback': 'Biomarcador',
        'noData': 'Sin datos',
        'empty': 'No hay categorías disponibles o cargando...',
        'evolutionTitle': 'Evolución Histórica',
        'loadingHistory': 'Cargando histórico...',
        'noHistory': 'No hay datos históricos suficientes.',
        'value': 'Valor'
      }
    },
    'xugarboard': {
      'duration': 'Duración'
    },
    'signin': {
      'license': 'Licencia (Opcional)',
      'notValidLicense': 'El código de licencia es inválido'
    },
    'login': {
      'title': 'Bienvenido a My Glucovibes',
      'licenseError': 'Tu licencia ha caducado'
    },
    'updateLicense': {
      'title': 'Actualizar licencia',
      'expirationDate': 'Fecha de expiración',
      'subscriptions': 'Suscripciones',
      'addSubscription': 'Añadir suscripción',
      'update': 'Actualizar',
      'success': 'La licencia se ha actualizado correctamente',
      'shop': '¿Necesitas una nueva licencia? Consíguela <a href="https://glucovibes.com/tienda/">aquí</a>',
      'accountSuccessfullyActivated': 'Tu plan Viber ha sido activado con éxito',
      'errorActivatingAccount': 'Ha ocurrido un error al activar tu plan Viber',
      'errorActivatingAccountAlreadyHaveEntitlement': 'Ya dispones de un plan Viber activo.',
      'errorActivatingAccountInvalidLicense': 'Por favor, verifica la clave de licencia o la URL proporcionada y asegúrate de que sea correcta. Si crees que esto es un error, por favor, contacta con <a href="mailto:soporte@xugarhero.com">soporte@xugarhero.com</a> para obtener ayuda.',
      'errorActivatingAccountDetailsRetry': 'Por favor, inténtalo de nuevo en unos minutos o ponte en contacto con <a href="mailto:soporte@xugarhero.com">soporte@xugarhero.com</a> si el error persiste.',
      'errorActivatingAccountDetails': 'Por favor, ponte en contacto con <a href="mailto:soporte@xugarhero.com">soporte@xugarhero.com</a>.'
    },
    'userProfile': {
      'expirationDate': 'Fecha de vencimiento',
      'nutritionalPlanExpirationDate': 'Fecha de vencimiento del plan nutricional',
      'license': 'Licencia',
      'prescriptor': 'Prescriptor',
      'prescriptorDoesNotMatchUser': 'No hay ningún prescriptor/nutricionista con ese nombre de usuario',
      'update': 'Actualizar',
      'expired': 'La licencia de este usuario ha caducado',
      'nutritionalPlanExpired': 'Este usuario no dispone de plan nutricional',
      'address': 'Dirección',
      'noAddress': 'El usuario no ha introducido ninguna dirección',
      'upgradeToViber': 'Obtener suscripción Viber',
      'upgradeToViberPlus': 'Obtener suscripción Viber Plus+',
      'deleteAccount': {
        'title': 'Eliminar cuenta',
        'message': '¿Estás seguro de que deseas eliminar tu cuenta? Esta acción no se puede deshacer',
        'successMessage': 'Tu cuenta ha sido eliminada correctamente',
        'errorMessage': 'Ha ocurrido un error al eliminar tu cuenta'
      }
    },
    'nutritionalPlanTemplate':{
      'title': 'Plantillas del Plan Nutricional',
      'description': 'Descripción',
      'create': 'Crear nueva plantilla',
      'delete': '¿Estás seguro que quieres eliminar?',
      'new': 'Crear nueva plantilla',
      'edit': 'Editar plantilla',
      'selector':'Seleccionar plantilla',
      'loading': 'Cargando plantillas...',
      'noTemplate': 'No tienes plantillas creadas',
      'errorLoading': 'Error cargando las plantillas',
      'errorRecipes': 'Error al cargar las recetas de la plantilla',
      'confirmApply': '¿Estás seguro de que deseas aplicar esta plantilla? Reemplazará el plan actual.',
      'saveTemplate': 'Guardar',
      'confirmSave': 'La plantilla se ha guardado correctamente',
      'errorChangeRecipe': 'Error cambiando la receta: ',
      'errorGettingRecipes': 'Error al obtener las recetas de la plantilla: ',
      'saveAsTemplate': 'Guardar como plantilla'
    },
    'nutritionalPlan': {
      'meal': 'Comida',
      'exportPdf': 'Exportar',
      'menu': 'Plan nutricional',
      'calendar': 'Calendario nutricional',
      'title': 'Ingestas',
      'addIngest': 'Añadir ingesta',
      'addTemplate': 'Añadir plantilla',
      'addFood': 'Añadir alimento',
      'name': 'Nombre',
      'type': 'Tipo',
      'intensity': 'Intensidad',
      'active': 'Activo',
      'amount': 'Cantidad (g)',
      'foodAmount': 'Cantidad',
      'templateSelector': 'Selector de Plantillas',
      'templates': 'Plantillas',
      'foods': 'Alimentos',
      'food': 'Alimento',
      'foodsSelector': 'Selector de Alimentos',
      'delete': 'Eliminar Plan',
      'deleteFood': 'Eliminar alimento',
      'editFormTitle': 'Editar Ingesta',
      'editTemplate': 'Edit Template',
      'noWeight': 'Este usuario no ha introducido su peso',
      'maxIngestsOfType': 'Has seleccionado la cantidad máxima de ingestas para los tipos',
      'mealTypes': [
        'Desayuno',
        'Almuerzo',
        'Comida',
        'Merienda',
        'Cena'
      ],
      'weekDays': {
        'monday': 'Lunes',
        'tuesday': 'Martes',
        'wednesday': 'Miércoles',
        'thursday': 'Jueves',
        'friday': 'Viernes',
        'saturday': 'Sabado',
        'sunday': 'Domingo'
      },
      'mealTypes2': {
        "Desayuno": "Desayuno",
        "Almuerzo": "Almuerzo",
        "Comida": "Comida",
        "Merienda": "Merienda",
        "Cena": "Cena"
      },
      'selectDayAndMealType':'Selecciona un día y un tipo de comida',
      'noPlan': 'El usuario no tiene ningún plan asignado'
      ,
      'colors': {
        'white': 'Blanco',
        'red': 'Rojo',
        'yellow': 'Amarillo',
        'purple': 'Morado',
        'green': 'Verde'
      },
      'gramsKilo': 'Gramos / kg',
      'percentage': 'Porcentaje',
      'free': 'Libre',
      'modeTitle': 'Modo de trabajo del plan nutricional',
      'successUpdateMode': 'El modo ha sido actualizado correctamente',
      'errorUpdateMode': 'Ha ocurrido un error al actualizar el modo',
      'successDelete': 'La ingesta {name} ha sido eliminada',
      'successTemplatelete': 'La plantilla {name} ha sido eliminada',
      'errorDelete': 'Ha ocurrido un error al eliminar la ingesta {name}',
      'errorTemplateDelete': 'Ha ocurrido un error al eliminar la plantilla {name}',
      'successUpdate': 'La ingesta se ha actualizado correctamente',
      'successTemplateUpdate': 'La plantilla se ha actualizado correctamente',
      'errorUpdate': 'Ha ocurrido un error al actualizar la ingesta',
      'errorTemplateUpdate': 'Ha ocurrido un error al actualizar la plantilla',
      'errorAddFood': 'Ha ocurrido un error al añadir el alimento',
      'successCalendarUpdate': 'El plan semanal se ha actualizado correctamente',
      'errorCalendarUpdate': 'Ha ocurrido un error al actualizar el plan semanal',
      'protein': 'Proteinas (g)',
      'fat': 'Grasas (g)',
      'carbs': 'Carbohidratos (g)',
      'calories': 'Calorias (kcal)',
      'proteinKg': 'Proteinas (g/kg)',
      'fatKg': 'Grasas (g/kg)',
      'carbsKg': 'Carbohidratos (g/kg)',
      'caloriesKg': 'Calorias (kcals/kg)',
      'fibre': 'Fibra (g)',
      'modifyAmount': 'Modificar cantidad',
      'amountInG': 'Cantidad en gramos',
      'amountModifyError': 'Se debe introducir un número',
      'carbsFactor': 'Factor de carbohidratos',
      'fatsFactor': 'Factor de grasas',
      'proteinsFactor': 'Factor de proteinas',
      'caloriesFactor': 'Factor de calorias',
      'theoreticalTotal': 'Total teórico (g)',
      'realTotal': 'Total real (g)',
      'adjustAmounts': 'Ajustar cantidades',
      'errorExceededCarbs': 'Los alimentos no empleados para el ajuste han sobrepasado la cantidad de carbohidratos necesarios',
      'negativeAmount': 'La cantidad no puede ser negativa',
      'carbsFactorZero': 'El factor de carbohidratos debe ser mayor que 0',
      'negativeFactors': 'Los factores de los macros deben ser mayores que 0',
      'typeNotSelected': 'Por favor selecciona el tipo de ingesta',
      'planNameConflict': 'Ya hay un plan nutriticional con ese nombre',
      'templateNameConflict': 'Ya hay una plantilla con ese nombre',
      'notGramsKiloMode': 'Este usuario no utiliza el método de gramos/kg',
      'show': 'Mostrar',
      'successUpdateVisibility': 'La visibilidad de la ingesta se ha actualizado correctamente',
      'errorUpdateVisibility': 'Ha ocurrido un error al actualizar la visibilidad de la ingesta',
      'summary': 'Resumen',
      'selectDay': 'Selecciona día',
      'selectMeal': 'Selecciona tipo de comida',
      'addRecipe': 'Añadir receta',
      'ingredients': 'Ingredientes',
      'addFoodGroup13': 'Añadir suplementos',
      'recipesSelector': 'Selector de Recetas',
      'recipes': 'Recetas',
      'filterByTag': 'Filtar por etiqueta',
      'allTypes': 'Filtrar por comida',
      'glucoseCurve': 'Valoración de la glucosa prevista(mg/dL)',
      'timeMinutes': 'Time (minutes)',
      'upperLimit': 'Límite superior',
      'lowerLimit': 'Límite inferior',
      'updateRecipe' : 'El plan ha sido modificado correctamente',
      'update': 'Actualizar',
      'recipeAlreadyAssigned': 'Ya hay una receta asignada para este día y tipo de comida. ¿Deseas reemplazarla?',
      'errorUpdateRecipe': 'Error al actualizar el plan',
      'reset': 'Empezar desde cero',
      'confirmReset': '¿Estás seguro que quieres borrar el plan?',
      'noLooseFood' : 'Solo se pueden añadir alimentos a una receta',
      'assign28Days': 'Asignar plan de 28 días',
      'confirm28Days': '¿Seguro que quieres asignar este plan de 28 días? Se sobreescribirán los datos existentes.',
      'planAssigned': 'Plan de 28 días asignado correctamente.',
      'errorAssignPlan': 'Error al asignar el plan de 28 días.',
      /* Prototype */
      'prototype': {
        'noNutritionalPlanResult': 'No hay resultados para el plan nutricional con las kcal seleccionadas',
        'recalculate': 'Recalcular',
        'daysOfPlan': 'Días de plan',
        'breakfast': 'Desayuno',
        'breakfastSnack': 'Snack de desayuno',
        'lunch': 'Comida',
        'lunchSnack': 'Snack de comida',
        'dinner': 'Cena',
        'total': 'Total',
        'addBreakfastSnack': 'Añadir snack de desayuno',
        'addLunchSnack': 'Añadir snack de comida',
        'weekdays': [
          'Lunes',
          'Martes',
          'Miércoles',
          'Jueves',
          'Viernes',
          'Sábado',
          'Domingo'
        ],
      }
    },
    'subscription': {
      'title': 'Suscripción',
      'daily': 'Un día',
      'threeDays': 'Tres días',
      'weekly': 'Una semana',
      'monthly': 'Un mes',
      'twoMonths': 'Dos meses',
      'threeMonths': 'Tres meses',
      'sixMonths': 'Seis meses',
      'yearly': 'Un año',
      'lifetime': 'Por siempre'
    },
    'license': {
      'license': 'Licencia',
      'description': 'Descripción',
      'entitlement': 'Entitlement',
      'duration': 'Duración',
      'order': 'Pedido',
      'productId': 'Id del producto',
      'date': 'Fecha',
      'new': 'Crear licencia',
      'deleteModalMessage': 'Eliminar licencia',
      'successDelete': 'La licencia ha sido eliminada con éxito',
      'errorDelete': 'Ha ocurrido un error al eliminar la licencia',
      'coupon': 'Cupón',
      'invalidCoupon': 'Cupón inválido',
      'amount': 'Cantidad',
      'successProcessLicenses': 'Las licencias han sido creadas con éxito',
      'errorProcessLicenses': 'Ha ocurrido un error al procear las licencias'
    },
    'patient': {
      'title': 'Pacientes',
      'username': 'Username',
      'name': 'Nombre',
      'surname': 'Apellidos',
      'email': 'Email',
      'sex': 'Sexo',
      'weight': 'Peso',
      'height': 'Altura',
      'objective': 'Objetivo',
      'weeklyTrainings': 'Entrenamientos semanales',
      'averageTrainingTime': 'Duración media de actividad',
      'objectiveWeight': 'Peso objetivo',
      'caloricNeeds': 'kcals',
      'birthday': 'Fecha de nacimiento',
      'integrations': 'Integraciones',
      'sexType': {
        'masculine': 'Masculino',
        'feminine': 'Femenino'
      },
      'firstOption':'Plan nutricional',
      'secondOption':'Analíticas',
      'thirdOption':'Anotación',
      'objectiveType': {
        'loseWeight': 'Perder peso',
        'gainMuscleMass': 'Ganar masa muscular',
        'improveSportPerformance': 'Mejorar mi rendimiento deportivo',
        'learnToEatBetter': 'Aprender a comer mejor',
        'improveRestQuality': 'Mejorar la calidad de mi sueño',
        'feelMoreEnergetic': 'Sentirme más enérgico'
      }
    },
    'assignPatients': {
      'title': 'Asignar pacientes',
      'nutritionistSelector': 'Selector de nutricionista',
      'nutritionists': 'Nutricionistas',
      'successAssignNutritionist': 'El nutricionista se ha asignado correctamente'
    },
    'exploreRecommendations': {
      'title': 'Recomendaciones de \'Explora\'',
      'recommended': 'Recomendado',
      'name': 'Nombre',
      'errorUpdating': 'Ha ocurrido un error al actualizar las recomendaciones',
      'successUpdating': 'Las recomendaciones han sido actualizadas con éxito'
    },
    'challenge': {
      'newTemplate': 'Crear plantilla',
      'templates': 'Plantillas de retos',
      'challenges': 'Retos',
      'activeAndFutureChallenges': 'Retos activos y futuros',
      'category': 'Categoría',
      'categories': {
        'glucose': 'Glucemia',
        'sport': 'Actividad',
        'nutrition': 'Nutrición',
        'rest': 'Descanso',
        'vibeBattery': 'VibeBattery'
      },
      'type': 'Tipo',
      'types': {
        'accumulated': 'Acumulado',
        'accumulatedLabel': 'Acumulado (Da 100.000 pasos durante este mes.)',
        'streak': 'Racha',
        'streakLabel': 'Racha (Da 10.000 pasos al día durante 5 días seguidos de este mes.)',
        'days_count': 'Días cumpliendo',
        'days_countLabel': 'Días cumpliendo (Da 10000 pasos al día al menos 5 días de este mes.)'
      },
      'operatorTypes': {
        'first': 'Primer valor',
        'last': 'Último valor',
        'count': 'Número de datos',
        'min': 'Valor mínimo',
        'max': 'Valor máximo',
        'sum': 'Suma de valores',
        'avg': 'Media de valores'
      },
      'name': 'Nombre ES',
      'nameEng': 'Nombre EN',
      'description': 'Descripción ES',
      'descriptionEng': 'Descripción del resultado EN',
      'resultDescription': 'Descripción del resultado ES',
      'resultDescriptionEng': 'Descripción del resultado EN',
      'formula': 'Fórmula',
      'startDate': 'Fecha de inicio',
      'endDate': 'Fecha de fin',
      'daysOfDuration': 'Días de duración',
      'level': 'Nivel',
      'levels': 'Niveles',
      'addLevel': 'Añadir nivel',
      'streakDays': 'Días en racha',
      'fulfillingDays': 'Días cumpliendo',
      'accumulatedValue': 'Valor acumulado',
      'addVariable': 'Añadir variable',
      'addConstant': 'Añadir constante',
      'categoryNotSelectedError': 'La categoría no ha sido seleccionada',
      'noVariablesDataError': 'No hay variables para crear la fórmula',
      'noLevelsError': 'Se debe añadir al menos un nivel',
      'incompleteLevelDataError': 'La información de los niveles no está completa, completa todos los campos',
      'incompleteVariableDataError': 'La información de las variables no está completa, completa todos los campos',
      'incompletecomparationVariableDataError': 'La información de la variable de comparación no está completa, completa todos los campos',
      'maxLevelValueHigherThanDurationError': 'El valor de los niveles no puede ser mayor que la duración del reto.',
      'levelValueLowerThanZeroError': 'El valor de los niveles no puede ser menor o igual que 0.',
      'levelValuesAreNotAscending': 'Los valores de nivel no se ordenan de forma ascendente.',
      'levelValuesAreNotConsistentlyAscendingOrDescending': 'Los valores de nivel no se ordenan de forma ascendente o descendente.',
      'successCreateTemplate': 'La plantilla ha sido creada con éxito',
      'errorCreateTemplate': 'Ha ocurrido un error al crear la plantilla',
      'successDeleteTemplate': 'La plantilla ha sido eliminada con éxito',
      'deleteTemplateModalMessage': '¿Estás seguro de que deseas eliminar la plantilla? Esta acción no se puede deshacer',
      'errorDeleteTemplate': 'Ha ocurrido un error al eliminar la plantilla',
      'errorTemplateCreate': 'Ha ocurrido un error al crear la plantilla',
      'launchChallenge': 'Lanzar reto',
      'confirmLaunchMessage': '¿Estás seguro de que deseas lanzar el reto? Esta acción no se puede deshacer',
      'successChallengeCreated': 'El reto ha sido creado con éxito',
      'errorChallengeCreated': 'Ha ocurrido un error al crear el reto',
      'resultDescriptionFormat': 'Añade %s donde quieras que se muestre el valor acumulado ej. Has practicado deporte %s minutos.',
      'errorFetchingVariableReferences': 'Ha ocurrido un error al obtener las referencias de las variables.',
      'history': 'Histórico',
      'finishedChallenges': 'Retos finalizados',
      'participants': 'Participantes',
      'participant': {
        'username': 'Username',
        'email': 'Email',
        'maxLevel': 'Nivel alcanzado',
        'accumulatedValue': 'Valor acumulado',
        'maxStreak': 'Racha máxima',
        'currentStreak': 'Racha actual',
        'daysFulfilling': 'Días cumpliendo',
        'joinedAt': 'Unido en',
        'lastUpdate': 'Última actualización'
      }
    },
    'notificationMessages': {
      'title': 'Notificaciones',
      'messageCode': 'Código',
      'type': 'Tipo (Es)',
      'typeEng': 'Tipo (Eng)',
      'inAppMessage': 'Mensaje in app (Es)',
      'inAppMessageEng': 'Mensaje in app (Eng)',
      'pushMessage': 'Mensaje push (Es)',
      'pushMessageEng': 'Mensaje push (Eng)',
      'push': 'Push',
      'inApp': 'In app',
      'addMessage': 'Añadir mensaje',
      'editMessage': 'Editar mensaje',
      'messageCodeAlreadyExists': 'El código de mensaje ya existe',
      'messageSuccessfullyCreated': 'El mensaje se ha creado con éxito',
      'messageSuccessfullyUpdated': 'El mensaje ha sido actualizado con éxito',
      'new': 'Nuevo mensaje',
      'types': {
        'glucose': 'Glucosa',
        'nutrition': 'Alimentación',
        'activity': 'Actividad',
        'vibeBattery': 'VibeBattery',
        'rest': 'Descanso',
        'questionnaire': 'Cuestionario',
        'challenge': 'Reto',
        'happyBirthday': '¡Feliz cumpleaños Viber!',
        'other': 'Otro'
      }
    },
    'recipe': {
      'title': 'Recetas',
      'new': 'Añadir receta',
      'edit': 'Editar receta',
      'delete': 'Eliminar receta',
      'name': 'Nombre',
      'nameEn': 'Nombre (EN)',
      'type': 'Tipo',
      'glutenFree': 'Sin gluten',
      'vegetarian': 'Vegetariano',
      'vegan': 'Vegano',
      'pescetarian': 'Pescetariano',
      'ketogenic': 'Cetogénico',
      'basicCooking': 'Cocina básica',
      'successDelete': 'La receta ha sido eliminada con éxito',
      'errorDelete': 'Ha ocurrido un error al eliminar la receta',
      'successUpdate': 'La receta ha sido actualizada con éxito',
      'errorUpdate': 'Ha ocurrido un error al actualizar la receta',
      'successCreate': 'La receta ha sido creada con éxito',
      'errorCreate': 'Ha ocurrido un error al crear la receta',
      'errorNoImage': 'La receta debe tener una imagen',
      'errorNoType': 'La receta debe tener un tipo',
      'recipeHasToHaveItemsError': 'La receta tiene que tener al menos un ingrediente',
      'uploadImage': 'Subir imagen',
      'errorImageUpload': 'Ha ocurrido un error al subir la imagen',
      'totalGrams': 'Total (g)',
      'totalKcals': 'Total (kcal)',
      'kcalDistribution': 'Distribución de kcal',
      'predictedScore': 'Puntuación predicha',
      'predictedIsp': 'ISP Predicho',
      'favorites': 'Favoritos',
      'myRecipes': 'Mis recetas',
      'tags': 'Etiquetas de receta',
      'tag': {
        'title': 'Etiquetas',
        'name': 'Nombre',
        'nameEn': 'Nombre (EN)',
        'new': 'Añadir etiqueta',
        'edit': 'Editar etiqueta',
        'delete': 'Eliminar etiqueta',
        'successDelete': 'La etiqueta ha sido eliminada con éxito',
        'errorDelete': 'Ha ocurrido un error al eliminar la etiqueta',
        'successUpdate': 'La etiqueta ha sido actualizada con éxito',
        'errorUpdate': 'Ha ocurrido un error al actualizar la etiqueta',
        'successCreate': 'La etiqueta ha sido creada con éxito',
        'errorCreate': 'Ha ocurrido un error al crear la etiqueta',
        'nameExists': 'El nombre de la etiqueta ya existe'
      },
      'glucoRecipes':'Recetas de glucovibes',
      "recipePreviewInfo": "Puedes explorar cómo afectan los cambios en las cantidades de los ingredientes en los macronutrientes, ISP y más. Los cambios son orientativos y no se guardarán."
    },
    'menu': {
      'challengeManagement': 'Gestión de retos',
      'nutritionalPlanTest': 'Test de plan nutricional'
    },
    'corporateGroups': {
      'title': 'Grupos corporativos',
      'addCorporateGroup': 'Añadir grupo corporativo',
      'name': 'Nombre',
      'group': 'Grupo',
      'domain': 'Dominio',
      'domainWithoutAt': 'Dominio sin @ (Ej. glucovibes.com)',
      'activePlan': 'Plan Viber activo',
      'groupWithDomainAlreadyExists': 'Ya existe un grupo con ese dominio',
      'errorGettingGroups': 'Ha ocurrido un error al obtener los grupos'
    }, 'NutritionistNotes':{
      'title': 'Notas del nutricionista',
      'empty': 'No existe ninguna nota todavía',
      'allergies' : 'Alergias',
      'intolerances': 'Intolerancias',
      'preferences' : 'Preferencias',
      'food_dislike': 'Comida que no le gusta',
      'supplements': 'Suplementos',
      'additional_comment': 'Comentarios adicionales',
      'edit': 'Editar nota',
      'delete': 'Eliminar nota',
      'titleEdit': 'Editor de notas',
      'titleCreate': 'Creador de notas',
      'save': 'Guarda nota',
      'create': 'Crear nota',
      'cancel': 'Cancelar',
      'confirmDelete': 'Borrarla',
      'deleteConfirm': '¿Estás seguro que quieres borrar esta nota?',
      'menu':'Notas del  nutricionista',
      'selectPatient': 'Seleccionar paciente',
      'addNote': 'Añadir nota'
    }
  },
  'legal-termAndConditions': `
    <div>
      <h2>Condiciones de Uso y Aviso Legal</h2>
      <p>
          Con el ánimo de cumplir con lo establecido en la ley 34/2002 de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSI) se ofrece aquí información importante al usuario y a sus tutores en caso de que éste sea menor.
          Para cualquier aclaración o información adicional pueden dirigirse a:
      </p>
      <ul>
          <li>Empresa: : HX Digital Health SL (en adelante xugarhero)</li>
          <li>Nombre Comercial: xugarhero</li>
          <li>B05335377</li>
          <li>Sede fiscal: Juan Fermín Gilisagasti n2 oficina 312, 20018 Donostia, Gipuzkoa (España)</li>
          <li>Correo electrónico: info@xugarhero.com</li>
          <li>sitios web: www.xugarhero.com</li>
          <li>Aplicaciones oficiales en los Store Google Play y AppleStore.</li>
          <li>El fundador de xugarhero y sus socios son los propietarios de esta iniciativa y las derivadas de ésta.</li>
      </ul>
      <p>
        Los productos y servicios de xugarhero a los que el usuario final pueda acceder bien a través de Apps o directamente a través de un navegador web, estarán sujetos a las siguientes condiciones de uso con los consiguientes avisos legales mostrados en este documento.
      </p>

      <h3>Condiciones de uso</h3>
      <p>
      La iniciativa xugarhero y los productos y servicios de xugarhero particularizados para el sector salud, deporte, nutrición o similar en el que información del usuario tanto procedente de sensores (CGM) como introducida por éste o terceros a los que se ha permitido acceso estarán sujetos a estas condiciones de uso y futuras que podrán ser actualizadas en futuras versiones de este documento.
      </p>
      <p>
      El usuario utiliza sistemas CGM comerciales aportados por terceras empresas para generar información que xugarhero almacena. xugarhero y sus iniciativas en ningún caso sustituye a los servicios ofrecidos por el fabricante de los sistemas de medición de glucosa en continuo y sus CGMs, y los servicios de xugarhero no podrán ser utilizados para ningún tipo de diagnóstico o prescripción médica sustitutivos a los ya prestados por las aplicaciones o servicios de los fabricantes o distribuidores de los sistemas CGM de aplicación médica
      </p>
      <p>
      Los servicios e información ofrecida por xugarhero a través de su plataforma digital y/o aplicaciones móviles tienen carácter informativo y complementario a la información facilitada por el fabricante de los sistema CGM, y siempre fuera del ámbito del diagnóstico de salud, y siempre ligados a conocer cómo fluctúa la glucosa ante diferentes situaciones de la persona “no diabética” que haga uso de estos productos o servicios ofrecidospor xugarhero.
       </p>
      <p>
      El hecho de acceder a, permanecer en o usar dichos servicios o productos en cualquier de sus formas posibles implica que usted y las personas que puedan depender de usted, o terceras personas a las que dé acceso, han leído y aceptan en su totalidad este Aviso Legal y Condiciones de Uso así como la Política de Privacidad de xugarhero asociada a los datos manejados por los servicios y productos derivados de las iniciativas mencionadas. Tiene información para su conocimiento en los diferentes lugares públicos en la web que le rogamos leer con detalle para conocer la descripción, dimensión e impacto de los productos y servicios ofrecidos.
      </p>
      <p>
      A través de xugarhero, el cliente accede a una serie de servicios y productos desarrollados por la empresa y sus proveedores. El hecho de ser usuario de estas apps y servicios o productos web ofrecidos por xugarhero convierte al usuario en cliente, en caso de uso por parte de un menor, éste deberá tener consentimiento de bien su progenitor o progenitores o bien de su tutor o tutores. Los usuarios por el hecho de usar los servicios y productos descritos están de acuerdo con las Condiciones de Uso y Aviso Legal y la Política de Privacidad. En caso de no estar de acuerdo con ellas, deberá abandonar los servicios y productos de la iniciativa borrando incluso las apps de sus terminales móviles y solicitar el borrado de cualquier información facilitada por email a baja@xugarhero.com.
      </p>
      <p>
      Usted tiene la posibilidad de sumarse a este programa y participar en un análisis clínico donde la información y datos procedentes del usuario serán utilizados con fines científicos y comerciales para poder mejorar tanto el producto como para la promoción del mismo y su comercialización o cualquier otra actividad que xugarhero considere de interés. Salvo que indique lo contrario, la información facilitada al sistema será utilizada con estos fines garantizando la privacidad de sus datos y utilizando los mismos exclusivamente para fines científicos. El programa científico se aplica por defecto a todos los usuarios que acepten las condiciones de uso y aviso legal.
      </p>
      <p>
      El usuario al registrarse proporciona un nombre completo, nombre de usuario y correo electrónico así como información básica que será tratada y almacenada por xugarhero del mismo modo que la información agregada por el usuario de forma manual o bien a través de terceras partes como pueden ser sensores, otras apps o servicios web, productos de terceros o similar. La aplicación ofrece un modo “invitado” que aquellos usuarios que no deseen registrarse podrán utilizar. Este modo invitado está limitado solo a algunas opciones y está sujeto a cambios e incluso su permanencia puede ser modificada y decidida por xugarhero de forma unilateral sin consentimiento alguno por parte de los usuarios.
      </p>
      <p>
      xugarhero no se hace responsable de los privilegios de instalación otorgados por un tutor a una persona menor. En el caso de xugarhero orientado al tratamiento, gestión y educación diabetológica, se sugiere encarecidamente la supervisión de un adulto o tutor cuando el menor esté utilizando las apps, productos o servicios. xugarhero no es una herramienta de diagnóstico y cualquier decisión tomada por el usuario o su progenitor exonera a xugarhero y sus proveedores e incluso a los fabricantes de los sistemas CGM utilizados por el usuario con los productos de xugarhero de cualquier responsabilidad.
      </p>
      <h3>Exclusión de responsabilidad</h3>
      <p>
      LOS SERVICIOS DE LA INICIATIVA XUGARHERO no son un dispositivo médico ni sustituyen la prospección o criterio de un médico. Se trata de una herramienta educativa y que permite una gestión de los datos asociados a las diabetes, nutrición, deporte y hábitos de vida, pero no genera diagnósticos, tratamientos o similares y SIEMPRE han de contrastarse con el criterio de un médico y/o profesional del sector.
      </p>
      <p>
      Asimismo xugarhero no se hacen responsables de la información o uso que el usuario pueda hacer de links a terceros que puedan encontrarse en los diferentes productos o servicios ofrecidos, quedando exclusivamente en manos del usuario la responsabilidad el uso que le dé a dicha información encontrada en links o derivados procedentes de terceros. A este respecto, se incluyen terceras aplicaciones que el usuario decida utilizar para la comunicación entre apps y sensores de monitorización continua de glucosa CGM, como es el caso de Diabox, nightscout o similares. xugarhero no es propietario ni tiene relación comercial con estas empresas o iniciativas, de forma que es responsabilidad del usuario final su utilización y xugarhero no se responsabiliza de las consecuencias o infracciones de copyright que estas terceras empresas puedan haber cometido o cometer en el futuro con otros actores como los fabricantes de CGM. Recordamos que los fabricantes de los sistemas CGM cuentan son sus aplicaciones oficiales para el correcto uso de los CGM con el fin de generar un diagnóstico dentro del campo de la diabetes.
      </p>
      <p>
      xugarhero recomienda el uso de CGMs comerciales, y no tiene ninguna responsabilidad sobre ellos ni sus fabricantes, quedando sobre el usuario final la relación entre empresa fabricante de los CGMs y su utilización o problemas de garantía. Así mismo, xugarhero recomienda seguir las instrucciones del fabricante de los productos CGM para su colocación y retirada una vez su vida se consuma, , sin alterar las indicaciones del fabricante y sin utilizar aplicaciones de terceros que puedan modificar las características de tiempo y durabilidad de los sistemas que el fabricante recomienda y aprueba.
      </p>
      <h3>Derechos de Propiedad Intelectual e Industrial</h3>
      <p>
      xugarhero se reserva todos los derechos de la iniciativa xugarhero y de las apps, productos o servicios asociados. Los contenidos de las apps, sitio web, incluyendo pero sin limitar a textos, imágenes, fotografías, dibujos, diseños logotipos, gráficos, marcas, iconos, combinaciones de colores o cualquier otro elemento, su estructura y diseño, la forma de presentación de los materiales incluidos en la misma y el software, links y demás contenidos audiovisuales y sonoros, así como su diseño gráfico y códigos fuente necesarios para su funcionamiento, acceso y utilización, están protegidos por los derechos de Propiedad Industrial e Intelectual, pertenecientes a xugarhero o de terceros si se diera el caso, sin que puedan entenderse cedidos los derechos de explotación de los mismos más allá de lo necesario para el servicio prestado. Cualquier reproducción, transformación, distribución, comunicación pública, puesta a disposición del público y en general cualquier otra forma de explotación, independientemente del procedimiento empleado para ello, de todo o parte de los contenidos asociados a la iniciativa en cualquier plataforma o medio queda terminantemente prohibida, así como de su diseño y la selección y forma de presentación de los materiales incluidos en la misma. Del mismo modo, queda prohibida cualquier iniciativa de ingeniería inversa asociada a un intento de copia o réplica e incluso el análisis interno de las bases, metodologías, descubrimientos e incluso el propio código fuente de cualquiera de los elementos necesarios para el correcto funcionamiento de los servicios y productos xugarhero. Las aplicaicones de terceros que el usuario considere utilizar para comunicar los CGM comerciales con las apps y servicios de xugarhero no son propiedad de xugarhero y por lo tanto, xugarhero no ostenta derechos de propiedad intelectual sobre ellos ni por ende, responsabilidad alguna sobre ellos.
      </p>
      <h3>Nulidad</h3>
      <p>
      Si en un supuesto alguna de las cláusulas aquí descritas es declarada nula, el resto seguirán vigentes.
      </p>
      <h3>Modificación de las presentes Condiciones de Uso y Aviso Legal</h3>
      <p>
      xugarhero se reserva el derecho de modificar a voluntad el presente aviso legal y condiciones de uso así como las políticas de privacidad en el momento que se considere oportuno, y quedará actualizado en este mismo link a disposición del usuario.
      </p>
      <h3>Jurisdicción y Ley aplicable</h3>
      <p>
      Todas las disposiciones del presente Aviso Legal y Condiciones de Uso se regirán o interpretarán conforme a la legislación española vigente en cada momento en aquello que no esté expresamente establecido. Usted y xugarhero acuerdan someter cualquier controversia que pudiera suscitarse respecto a lo establecido en el presente Aviso Legal y Condiciones de Uso, a los Juzgados y Tribunales del domicilio de xugarhero en Donostia.
      <p>
    </div>
    `,
  'legal-privacyPolicy': `
  <div>
     <h2>Política de Privacidad</h2>
      <p>
      xugarhero te informa sobre su Política de Privacidad respecto del tratamiento y protección de los datos de carácter personal de los usuarios y clientes que puedan ser recabados por la navegación o contratación de servicios a través de la iniciativa xugarhero y otras derivadas de xugarhero bien en sus sitios web o apps habilitadas en la AppleStore, Googleplay o cualquier otro medio físico o digital donde puedan adquirirse sus servicios y productos.
      </p>
      <p>
      En este sentido, el Titular garantiza el cumplimiento de la normativa vigente en materia de protección de datos personales, reflejada en la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y de Garantía de Derechos Digitales (LOPD GDD). Cumple también con el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo de 27 de abril de 2016 relativo a la protección de las personas físicas (RGPD).
      </p>
      <p>
      El uso del sitio Web y las apps o productos y servicios asociados implica la aceptación de esta Política de Privacidad así como las condiciones incluidas en el Aviso Legal.
      </p>

      <h3>Identidad del responsable</h3>
      <ul>
        <li>Empresa: XH DIGITAL HEALTH S.L.</li>
        <li>Nombre Comercial: xugarhero</li>
        <li>B05335377</li>
        <li>Sede fiscal: Juan Fermín Gilisagasti n2 oficina 312, 20018 Donostia, Gipuzkoa (España)</li>
        <li>Correo electrónico: info@xugarhero.com</li>
        <li>Sitios web: www.xugarhero.com</li>
        <li>Aplicaciones oficiales en los Store Google Play y AppleStore.</li>
        <li>xugarhero y cualquier iniciativa derivada de ésta es propiedad del fundador de XH Digital Solutions SL y sus socios.</li>
      </ul>

      <h3>Principios aplicados en el tratamiento de datos</h3>
      <p>
      En el tratamiento de tus datos personales, el Titular aplicará los siguientes principios que se ajustan a las exigencias del nuevo reglamento europeo de protección de datos:
      </p>
      <ul>
        <li>Principio de licitud, lealtad y transparencia: El Titular siempre requerirá el consentimiento para el tratamiento de tus datos personales que puede ser para uno o varios fines específicos sobre los que te informará previamente con absoluta transparencia.</li>
        <li>Principio de minimización de datos: El Titular te solicitará solo los datos estrictamente necesarios para el fin o los fines que los solicita.</li>
        <li>Principio de limitación del plazo de conservación: Los datos se mantendrán durante el tiempo estrictamente necesario para el fin o los fines del tratamiento. El Titular te informará del plazo de conservación correspondiente según la finalidad. En el caso de suscripciones, el Titular revisará periódicamente las listas y eliminará aquellos registros inactivos durante un tiempo considerable.</li>
        <li>Principio de integridad y confidencialidad: Tus datos serán tratados de tal manera que su seguridad, confidencialidad e integridad esté garantizada. Debes saber que el Titular toma las precauciones necesarias para evitar el acceso no autorizado o uso indebido de los datos de sus usuarios por parte de terceros.</li>
      </ul>

      <h3>Obtención de datos personales</h3>
      <p>
      Para hacer uso de xugarhero es necesario que facilites datos personales, si bien existe un modo invitado con funcionalidades limitadas en el que no es necesario aportar ningún dato personal. Los casos en los que sí proporcionas tus datos personales son los siguientes:
      </p>
      <ul>
        <li>Registro en las aplicaciones y/o plataforma digital web.</li>
        <li>Hacer uso de las apps o los servicios de  xugarhero.</li>
        <li>Participar en cualquiera de los programas o análisis clínicos ligados a la iniciativa xugarhero.</li>
        <li>Al ponerte en contacto con nosotros a través del sitio web.</li>
      </ul>

      <h3>Tus derechos</h3>
      <p>
      El Titular te informa que sobre tus datos personales tienes derecho a:
      </p>
      <ul>
        <li>Solicitar el acceso a los datos almacenados.</li>
        <li>Solicitar una rectificación o la cancelación.</li>
        <li>Solicitar la limitación de su tratamiento.</li>
        <li>Oponerte al tratamiento.</li>
        <li>Solicitar la portabilidad de tus datos (se pueden realizar directamente desde el explorador para los usuarios de pago).</li>
      </ul>
      <p>
      El ejercicio de estos derechos es personal y por tanto debe ser ejercido directamente por el interesado, solicitándolo directamente al Titular, lo que significa que cualquier cliente, suscriptor o colaborador que haya facilitado sus datos en algún momento puede dirigirse al Titular y pedir información sobre los datos que tiene almacenados y cómo los ha obtenido, solicitar la rectificación de los mismos, solicitar la portabilidad de sus datos personales, oponerse al tratamiento, limitar su uso o solicitar la cancelación de esos datos en los ficheros del Titular.
      </p>
      <p>
      Para ejercitar tus derechos de acceso, rectificación, cancelación, portabilidad y oposición tienes que enviar un correo electrónico a info@xugarhero.com junto con la prueba válida en derecho como una fotocopia del D.N.I. o equivalente.
      </p>
      <p>
      Tienes derecho a la tutela judicial efectiva y a presentar una reclamación ante la autoridad de control, en este caso, la Agencia Española de Protección de Datos, si consideras que el tratamiento de datos personales que te conciernen infringe el Reglamento.
      </p>

      <h3>Finalidad del tratamiento de datos personales</h3>
      <p>
      Cuando te conectas al sitio Web o apps para mandar un correo al Titular, te suscribes a su boletín o realizas una contratación, estás facilitando información de carácter personal de la que el responsable es el Titular. Esta información puede incluir datos de carácter personal como pueden ser tu dirección IP, nombre y apellidos, dirección física, dirección de correo electrónico, número de teléfono, y otra información. Al facilitar esta información, das tu consentimiento para que tu información sea recopilada, utilizada, gestionada y almacenada por superadmin.es , sólo como se describe en el Aviso Legal y en la presente Política de Privacidad.
      </p>
      <p>
      Los datos personales y la finalidad del tratamiento por parte del Titular es diferente según el sistema de captura de información:
      </p>
      <ul>
        <li>Formularios de contacto: El Titular solicita datos personales entre los que pueden estar: Nombre y apellidos, dirección de correo electrónico, número de teléfono y dirección de tu sitio Web con la finalidad de responder a tus consultas. Por ejemplo, el Titular utiliza esos datos para dar respuesta a tus mensajes, dudas, quejas, comentarios o inquietudes que puedas tener relativas a la información incluida en el sitio Web, los servicios que se prestan a través del sitio Web, el tratamiento de tus datos personales, cuestiones referentes a los textos legales incluidos en el sitio Web, así como cualquier otra consulta que puedas tener y que no esté sujeta a las condiciones del sitio Web o de la contratación.</li>
        <li>Formularios de suscripción a contenidos: El Titular solicita los siguientes datos personales: Nombre y apellidos, dirección de correo electrónico, número de teléfono y dirección de tu sitio web para gestionar la lista de suscripciones, enviar boletines, promociones y ofertas especiales. Los datos que facilites al Titular pueden estar almacenados en empresas proveedoras de servicios contratadas por xugarhero. xugarhero no se hace responsable del uso que se den a estos datos por terceras empresas y se remite al usuario a sus respectivas políticas de privacidad para cada servicio particular no ofrecido directamente por xugarhero.</li>
      </ul>
      <p>
      Existen otras finalidades por las que el Titular trata tus datos personales:
      </p>
      <ul>
        <li>Para garantizar el cumplimiento de las condiciones recogidas en el Aviso Legal y en la ley aplicable. Esto puede incluir el desarrollo de herramientas y algoritmos que ayuden a este sitio Web a garantizar la confidencialidad de los datos personales que recoge.</li>
        <li>Para apoyar y mejorar los servicios que ofrece este sitio Web y los productos asociados a la iniciativa xugarhero.</li>
        <li>Para analizar la navegación. El Titular recoge otros datos no identificativos que se obtienen mediante el uso de cookies que se descargan en tu ordenador cuando navegas por el sitio Web y apps cuyas características y finalidad están detalladas en la Política de Cookies.</li>
        <li>Para gestionar las redes sociales. El Titular tiene presencia en redes sociales. Si te haces seguidor en las redes sociales del Titular el tratamiento de los datos personales se regirá por este apartado, así como por aquellas condiciones de uso, políticas de privacidad y normativas de acceso que pertenezcan a la red social que proceda en cada caso y que has aceptado previamente.</li>
      </ul>
      <p>
      Puedes consultar las políticas de privacidad de las principales redes sociales en estos enlaces:
      </p>
      <ul>
        <li>Facebook</li>
        <li>Twitter</li>
        <li>Linkedin</li>
        <li>YouTube</li>
        <li>Instagram</li>
        <li>Google</li>
        <li>Apple</li>
      </ul>
      <p>
      El Titular tratará tus datos personales con la finalidad de administrar correctamente su presencia en la red social, informarte de sus actividades, productos o servicios, así como para cualquier otra finalidad que las normativas de las redes sociales permitan.
      </p>
      <p>
      En ningún caso el Titular utilizará los perfiles de seguidores en redes sociales para enviar publicidad de manera individual.
      </p>

      <h3>Seguridad de los datos personales</h3>
      <p>
      Para proteger tus datos personales, el Titular toma todas las precauciones razonables y sigue las mejores prácticas de la industria para evitar su pérdida, mal uso, acceso indebido, divulgación, alteración o destrucción de los mismos.
      </p>
      <p>
      El sitio Web está alojado en Google y los servidores de la aplicación pueden estarlo en Google o AWS (Amazon). La seguridad de tus datos está garantizada, ya que toman todas las medidas de seguridad necesarias para ello. Puedes consultar su política de privacidad para tener más información.
      </p>

      <h3>Contenido de otros sitios web</h3>
      <p>
      Las páginas de este sitio Web pueden incluir contenido incrustado (por ejemplo, vídeos, imágenes, artículos, etc.). El contenido incrustado de otras web se comporta exactamente de la misma manera que si hubieras visitado la otra web.
      </p>
      <p>
      Estos sitios Web pueden recopilar datos sobre ti, utilizar cookies, incrustar un código de seguimiento adicional de terceros, y supervisar tu interacción usando este código.
      </p>

      <h3>Política de Cookies</h3>
      <p>
      Para que este sitio Web funcione correctamente necesita utilizar cookies, que es una información que se almacena en tu navegador web.
      </p>
      <p>
      En la página Política de Cookies puedes consultar toda la información relativa a la política de recogida, la finalidad y el tratamiento de las cookies.
      </p>

      <h3>Legitimación para el tratamiento de datos</h3>
      <p>
      La base legal para el tratamiento de tus datos es: el consentimiento.
      </p>
      <p>
      Para contactar con el Titular, suscribirte a un boletín o realizar comentarios en este sitio Web tienes que aceptar la presente Política de Privacidad.
      </p>

      <h3>Categorías de datos personales</h3>
      <p>
      Las categorías de datos personales que trata el Titular son:
      </p>
      <ul>
        <li>Datos identificativos.</li>
        <li>En los casos de uso de las app y plataforma digital, datos asociados a la salud, nutrición y deporte del usuario como: nivel de glucosa, actividad deportiva y constantes vitales como pulso, pasos realizados, desnivel realizado, y cualquier otro elemento y variable que identifique y describa la actividad realizada y el impacto en las constantes vitales de quien lo realiza, historial nutricional ligado a ingesta de carbohidratos, raciones, comidas, dietas, o similar, actividad de sueño y cualquier otra actividad realizada por el usuario recogida bien manualmente o bien a través de wearables o dispositivos de captación de este tipo de datos.</li>
      </ul>

      <h3>Conservación de datos personales</h3>
      <p>
      Los datos personales que proporciones al Titular se conservarán hasta que solicites su supresión.
      </p>

      <h3>Exactitud y veracidad de los datos personales</h3>
      <p>
      Te comprometes a que los datos facilitados al Titular sean correctos, completos, exactos y vigentes, así como a mantenerlos debidamente actualizados.
      </p>
      <p>
      Como Usuario del sitio Web y las apps derivadas de xugarhero eres el único responsable de la veracidad y corrección de los datos que remitas al sitio exonerando a el Titular de cualquier responsabilidad al respecto.
      </p>

      <h3>Aceptación y consentimiento</h3>
      <p>
      Como Usuario del sitio Web y las apps derivada de xugarhero declaras haber sido informado de las condiciones sobre protección de datos de carácter personal, aceptas y consientes el tratamiento de los mismos por parte de el Titular en la forma y para las finalidades indicadas en esta Política de Privacidad.
      </p>

      <h3>Revocabilidad</h3>
      <p>
      Para ejercitar tus derechos de acceso, rectificación, cancelación, portabilidad y oposición tienes que enviar un correo electrónico a baja@xugarhero.com junto con la prueba válida en derecho como una fotocopia del D.N.I. o equivalente.
      </p>
      <p>
      El ejercicio de tus derechos no incluye ningún dato que el Titular esté obligado a conservar con fines administrativos, legales o de seguridad.
      </p>

      <h3>Cambios en la Política de Privacidad</h3>
      <p>
      El Titular se reserva el derecho a modificar la presente Política de Privacidad para adaptarla a novedades legislativas o jurisprudenciales, así como a prácticas de la industria.
      </p>
      <p>
      Estas políticas estarán vigentes hasta que sean modificadas por otras debidamente publicadas.
      </p>
  </div>
  `
};



// WEBPACK FOOTER //
// ./src/brand/health/i18n/es_ES/translations.js